import { render, staticRenderFns } from "./FaceZoom.vue?vue&type=template&id=59a86b3f"
import script from "./FaceZoom.vue?vue&type=script&lang=js"
export * from "./FaceZoom.vue?vue&type=script&lang=js"
import style0 from "./FaceZoom.vue?vue&type=style&index=0&id=59a86b3f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports